// extracted by mini-css-extract-plugin
export var placeholderContainer = "map-module--placeholderContainer--2lvH7";
export var placeholderText = "map-module--placeholderText--34d0w";